import classNames from 'classnames';
import React from 'react';
import Icon from 'Components/Icon';
import Link from 'Components/Link/Link';
import { icons } from 'Helpers/Props';
import styles from 'Settings/AdvancedSettingsButton.css';

interface AdvancedSettingsButtonProps {
  advancedSettings: boolean;
  onPress: () => void;
}

export default function AdvancedSettingsButton({ advancedSettings, onPress }: AdvancedSettingsButtonProps) {
  const label = advancedSettings ? 'Hide Advanced' : 'Show Advanced';
  return <Link className={styles.button} title={`${label} settings`} onPress={onPress}>
    <Icon name={icons.ADVANCED_SETTINGS} size={21} />
    <span className={classNames(styles.indicatorContainer, 'fa-layers fa-fw')}>
      <Icon className={styles.indicatorBackground} name={icons.CIRCLE} size={16} />
      <Icon className={advancedSettings ? styles.enabled : styles.disabled} name={advancedSettings ? icons.CHECK : icons.CLOSE} size={10} />
    </span>
    <div className={styles.labelContainer}><div className={styles.label}>{label}</div></div>
  </Link>;
}
